/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useState, useEffect, useLayoutEffect } from "react";

// react-router components
import { useLocation, Link, useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";
import LogoutIcon from "@mui/icons-material/Logout";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";

// Material Dashboard 2 React example components
import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";
import { Autocomplete, Collapse, List, ListItemButton, ListItemIcon, ListItemText, Stack, TextField, Typography } from "@mui/material";
import { ExpandLess, ExpandMore, StarBorderOutlined } from "@mui/icons-material";
import OficinaService from "services/Oficina";
import { logout } from "auth";


function DashboardNavbar({ absolute, light, isMini }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator, darkMode } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);
  // const [notAdmin, setNotAdmin] = useState(!localStorage.getItem('rol_admin')|| false || undefined);
  // console.log(localStorage.getItem('rol_admin')) 


  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }  

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  function logOutHandler() {
    logout().catch((err) => {
      console.error("Logout failed", err);
    });
  }

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem icon={<Icon>email</Icon>} title="Check new messages" />
      <NotificationItem icon={<Icon>podcasts</Icon>} title="Manage Podcast sessions" />
      <NotificationItem icon={<Icon>shopping_cart</Icon>} title="Payment successfully completed" />
    </Menu>
  );

  // Styles for the navbar icons
  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });
  const [open, setOpen] = React.useState(false);
  const [oficinas, setOficinas] = useState([])
  const [selectedOficina, setSelectedOficina] = useState({})
  
  const handleClickCollapse = () => {
    async function getData(params) {
      const response = await OficinaService.getOficina(params);
      setOficinas(response.data);
      setOpen(!open);
    }
    getData({
      page: 0,
      rowsPerPage: 10,
      sortOrder: "ASC",
    });    
    
   
  };
  const navigate = useNavigate();
  function handleClick() {
    navigate("/informacion");
  }
  const handleOficina = (e) => {
    setSelectedOficina(oficinas.find((oficina) => oficina === e));
    // setLocalStorage();
  };

  // const setLocalStorage = () => {
  //   console.log('seteando el local storage')
  //   localStorage.setItem("id_oficina", selectedOficina.id_oficina);
  //                         localStorage.setItem("nombre_oficina",  selectedOficina.descripcion_oficina);
  //                         localStorage.setItem("nombre_fuero",  selectedOficina.descripcion_fuero);
  //                         localStorage.setItem("id_fuero",  selectedOficina.id_fuero)
  // }
  const [inputValue, setInputValue] = React.useState(
      `${localStorage.getItem("nombre_oficina") ?? ""} - 
      ${localStorage.getItem("nombre_fuero") ?? ""}`
    );

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
        </MDBox>
        {isMini ? null : (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            {/*... other commented code ... */}
            <MDBox
              color={light ? "white" : "inherit"}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                <Icon sx={iconsStyle} fontSize="medium">
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>

              {/* Wrap HumanName and nombre_oficina in a vertical container */}
              <MDBox sx={{ flexDirection: "column", marginRight: "auto" }}>
                {/* HumanName - Larger font size */}
                <div sx={{fontSize: "1.5em" }}>{localStorage.getItem("HumanName") ?? ""}</div>

                <div>
                  <List>
                    <ListItemButton onClick={handleClickCollapse}>
                      <ListItemText 
                        disableTypography
                        primary={<Typography variant="h6">{`${inputValue}`}</Typography>}>                          
                      </ListItemText>                                      
                          {open ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                                        
                      <Collapse in={open} timeout="auto" unmountOnExit>
                            <List  component="div" disablePadding>                        
                              <div>
                               
                                <Autocomplete
                                  sx={{width: "100%"}}
                                  id="size-small-standard"
                                  size="small"
                                  disableClearable
                                  options={oficinas}
                                  getOptionLabel={(option) => option.descripcion_oficina || `${localStorage.getItem("nombre_oficina")}` || null}
                                  defaultValue={selectedOficina}
                                  renderInput={(params) => (
                                      <TextField
                                            {...params}
                                            variant="standard"
                                            label="Oficina"                              
                                          />
                                        )}                          
                                        onChange={(event, newValue) => {
                                          handleOficina(newValue);
                                          setInputValue(newValue.descripcion_oficina + ' - '+ newValue.descripcion_fuero);
                                          localStorage.setItem("id_oficina", newValue.id);
                                          localStorage.setItem("nombre_oficina",  newValue.descripcion_oficina);
                                          localStorage.setItem("nombre_fuero",  newValue.descripcion_fuero);
                                          localStorage.setItem("id_fuero",  newValue.id_fuero);
                                          handleClick();                            
                                        }}
                                        onClose={() => setOpen(false)}                                /> 
                                      
                                </div>
                            </List>
                          </Collapse>                 
                    
                  </List>
                </div>

              </MDBox>
             

              <IconButton sx={navbarIconButton} size="large" disableRipple onClick={logOutHandler}>
                {/* <Icon sx={iconsStyle}>account_circle</Icon> */}
                <LogoutIcon />
              </IconButton>

              {/* Other commented code here */}
              {renderMenu()}
            </MDBox>
          </MDBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};




export default DashboardNavbar;
